export const ActionResult = Object.freeze({
  SAVED: 'saved',
  DELETED: 'deleted',
  CANCELED: 'canceled',
  ERROR: 'error',
});
